module.exports = __webpack_public_path__ + "assets/4e65cfc673ba4efadb361dbaa3b4e74c.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/drop/12/Drop_Scatter1.mp3
 ** module id = 211
 ** module chunks = 0
 **/